import {useEffect, useMemo, useState} from "react";
import {SelectItemType} from "../Types/FormTypes";

type FilterSelectType = {
    filterData: Array<SelectItemType>;
    exclusionList?: Array<number>;
    onStartCallback?: any;
    onEndCallback?: any;
    filterSecondaryValue?: boolean;
}

const useFilterSelectOptions = (props: FilterSelectType) => {
    const [ filterSelectValue, setFilterSelectValue ] = useState<string>('');
    const [ filterSelectItems, setFilterSelectItems ] = useState<Array<SelectItemType>>([]);
    const [ uniqueFilterSelectValue, setUniqueFilterSelectValue ] = useState<boolean>(false);
    const [ optionsCycled, setOptionsCycled ] = useState<boolean>(false);
    const [ filterReset, setFilterReset ] = useState<any>(null);

    const FilterSelectList = (event: any) => {
        let val = event.target.value;

        if(props.onStartCallback) {
            props.onStartCallback();
        }

        setFilterSelectValue(val ? val : '');

        val = val.toUpperCase();

        if (val) {
            let newList = [];
            let uniqueList: Array<SelectItemType> = [];

            for (let i = 0; i < props.filterData.length; i++) {
                let current = props.filterData[i];
                let value = val.toUpperCase();
                let entryValue = props.filterSecondaryValue ? current.label.toUpperCase() + current.valueSecondary?.toUpperCase() : current.label.toUpperCase();
                let strIndex = entryValue.indexOf(value);

                if (strIndex > -1) {
                    uniqueList.push(current);
                    if(!props.exclusionList?.includes(current.value)) {
                        newList.push(current);
                    }
                }
            }

            setFilterSelectItems(newList);
            setUniqueFilterSelectValue(uniqueList.every( value => value.label.toUpperCase() !== val));
        } else {
            setFilterSelectItems(props.filterData);
            setUniqueFilterSelectValue(false);
        }
    }

    const UpdateFilterSelectValue = (value: string = '') => {
        setFilterSelectValue(value);
    }

    const ResetFilterSelectOptions = () => {
        setFilterSelectItems(props.filterData);
        setFilterSelectValue('');
        setUniqueFilterSelectValue(false);
        setFilterReset(filterReset === null ? true : !filterReset);
    }

    const HandleFilterSelectFocus = (e: any, callBack?: any) => {
        const target = e.currentTarget;

        if(callBack) {
            callBack(e);
        }

        setTimeout(function() {
            target.focus();
            target.selectionStart = target.selectionEnd = target.value.length;
        }, 10);
    }

    const HandleFilterSelectBlur = (e: any, callBack?: any) => {
        setTimeout(() => {
            if(!document.activeElement?.closest('.multi-select-container')) {
                if(callBack) {
                    callBack(e);
                }
            }
        }, 50);
    }

    useEffect(() => {
        if(filterSelectItems && optionsCycled) {
            setOptionsCycled(false);
        }
    }, [filterSelectItems]);

    useEffect(() => {
        if(props.filterData) {
            setFilterSelectItems(props.filterData);
        }
    }, [props.filterData])

    return useMemo(() => ({
        filterReset,
        optionsCycled,
        filterSelectValue,
        filterSelectItems,
        uniqueFilterSelectValue,
        HandleFilterSelectBlur,
        HandleFilterSelectFocus,
        UpdateFilterSelectValue,
        FilterSelectList,
        ResetFilterSelectOptions
    }),[optionsCycled, filterReset, filterSelectItems, uniqueFilterSelectValue, filterSelectValue]);
}

export default useFilterSelectOptions